module Meevo.Plugins.ShippingFees {
    'use strict';

    export interface ShippingFeeMainSection{}

    export class ShippingFeeMainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<ShippingFeeMainSection> {
        public isEgiftEnabled: boolean;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum = null
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun);

        }

        createSectionModelInstance(postAdd: (data: any) => any) {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

    }
}
